<template>
    <div class="lxss_container">
        <!-- 栏目分类胶囊 -->
        <div class="lxss_tabs">
            <div
                class="lxss_tab"
                v-for="item in tabBtnInfo"
                :key="item.typeId"
                :class="{ active: tabTypeId === item.typeId }"
                @click="changeType(item.typeId)">
                {{ item.typeName }}
            </div>
        </div>

        <div class="lxss_content">
            <!-- 联系我们 -->
            <div :class="tabTypeId == 1 ? 'lxss_panel' : 'lxss_panel_hide'">
                <div class="lxwm_container reveal-init" v-reveal>
                    <div class="lxwm_map_container">
                        <div class="lxwm_img_container">
                            <el-image
                                style="width: 500px; height: 400px"
                                :src="companyInfo.img"
                                fit="contain">
                            </el-image>
                        </div>
                    </div>
                    <div class="lxwm__content_container">
                        <div class="lxwm__content_body">
                            <div class="lxwm__name_container">{{ companyInfo.name }}</div>
                            <div class="lxwm__tel_container">
                                <i class="el-icon-phone"></i>{{ companyInfo.tel }}
                            </div>
                            <div class="lxwm__address_container">
                                <i class="el-icon-map-location"></i>{{ companyInfo.province + companyInfo.city + companyInfo.address }}
                            </div>
                        </div>
                        <div class="lxwm__btns_body">
                            <el-button v-for="item in addressInfo" :key="item.id" @click="changeIt(item)">{{ item.reName }}</el-button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 咨询服务 -->
            <div :class="tabTypeId == 2 ? 'lxss_panel' : 'lxss_panel_hide'">
                <div class="zxfw_container reveal-init" v-reveal>
                    <div class="zxfw_zxly_container" v-loading.lock="loading">
                        <div class="zxfw_zxly_title">
                            <div class="zxfw_zxly_title_ch">在线留言</div>
                            <div class="dot"></div>
                            <div class="zxfw_zxly_title_en">ONLINE MESSAGES</div>
                        </div>
                        <div class="zxfw_zxly_form_container">
                            <div class="zxfw_zxly_form_body">
                                <el-form ref="form" :model="zxlyFormInfo" :rules="rules" label-width="60px">
                                    <el-form-item label="姓名" prop="msgname">
                                        <el-input v-model="zxlyFormInfo.msgname"></el-input>
                                    </el-form-item>
                                    <el-form-item label="手机" prop="msgtel">
                                        <el-input v-model="zxlyFormInfo.msgtel"></el-input>
                                    </el-form-item>
                                    <el-form-item label="留言" prop="msgtext">
                                        <el-input type="textarea" v-model="zxlyFormInfo.msgtext"></el-input>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button type="primary" @click="submitForm('form')">立即提交</el-button>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>
                    </div>
                    <div class="zxfw_csxx_container">
                        <div class="zxfw__content_body">
                            <div class="zxfw__name_container">江苏山水环境建设集团股份有限公司</div>
                            <div class="zxfw__net_container">
                                <span class="iconfont icon-net"></span>http://www.jsssjt.com
                            </div>
                            <div class="zxfw__tel_container">
                                <i class="el-icon-phone"></i>0511-87708008
                            </div>
                            <div class="zxfw__address_container">
                                <i class="el-icon-map-location"></i>江苏省镇江市句容市长江路399号
                            </div>
                            <div class="zxfw__gzhewm_container">
                                <el-image :src="gzhRwmImgUrl" fit="cover"></el-image>
                                <div class="zxfw__gzhewm_content">微信公众号</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 周边旅游 -->
            <div :class="tabTypeId == 3 ? 'lxss_panel' : 'lxss_panel_hide'">
                <div class="zxly_container reveal-init" v-reveal>
                    <swiper class="swiper" :options="swiperOption">
                        <swiper-slide class="slide-1" v-for="item in zblyInfo" :key="item.travelid">
                            <div class="zbly_item_container">
                                <div class="zbly_img_container">
                                    <el-image :src="item.travelimgurl" fit="cover"></el-image>
                                </div>
                                <div class="zbly_content_container">
                                    <div class="zbly_title_container">{{ item.travelname }}</div>
                                    <div class="zbly_text_container">{{ item.travetext }}</div>
                                </div>
                            </div>
                        </swiper-slide>
                        <div class="swiper-pagination swiper-pagination-grey" slot="pagination"></div>
                    </swiper>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      gzhRwmImgUrl: 'https://ssjt.buildone.com.cn/ewm1.jpg',
      tabTypeId: 1,
      activeCzlcId: '',
      location: {
        lng: 116.331398,
        lat: 39.897445
      },
      zoom: 16,
      addressKeyword: '',
      tabBtnInfo: [
        { typeName: '联系我们', typeId: 1 },
        { typeName: '咨询服务', typeId: 2 },
        { typeName: '周边旅游', typeId: 3 }
      ],
      addressInfo: [],
      companyInfo: {},
      zxlyFormInfo: {},
      rules: {
        msgname: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, message: '长度在 2 个字符以上', trigger: 'blur' }
        ],
        msgtel: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { min: 11, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        msgtext: [
          { required: true, message: '请填写留言', trigger: 'blur' }
        ]
      },
      swiperOption: {
        spaceBetween: 30,
        effect: 'fade',
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      zblyInfo: []
    }
  },
  methods: {
    // 获取公司列表
    getCompanyList () {
      this.$http.get('/admin/getCompanyList').then(res => {
        this.addressInfo = res.data.data
        this.namedAddress()
      })
    },
    // 获取周边旅游
    getTableData () {
      this.$http.get('/admin/getTravel').then(res => {
        this.zblyInfo = res.data.data
      })
    },
    handleClick (tab, event) {
      console.log(tab, event)
    },
    changeType (typeId) {
      this.tabTypeId = typeId
      if (this.$refs.form) this.$refs.form.resetFields()
    },
    ready (e) {
      const reallyAddress = '江苏省镇江市句容市长江路399号'
      this.showMaps(reallyAddress)
    },
    getLocationPoint (e) {
      this.lng = e.point.lng
      this.lat = e.point.lat
      const geoCoder = new window.BMap.Geocoder()
      geoCoder.getPoint(this.addressKeyword, point => {
        this.selectedLng = point.lng
        this.selectedLat = point.lat
      })
      geoCoder.getLocation(e.point, res => {})
    },
    showMaps (address) {
      const map = new window.BMap.Map('map')
      const myGeo = new window.BMap.Geocoder()
      myGeo.getPoint(address, function (point) {
        map.centerAndZoom(point, 16)
        map.addOverlay(new window.BMap.Marker(point))
      })
    },
    namedAddress () {
      const addressInfo = this.addressInfo
      for (let i = 0; i < addressInfo.length; i++) {
        if (addressInfo[i].name === '集团总部') {
          this.addressInfo[i].reName = addressInfo[i].name.substring(2, 4)
          let data = {}
          this.companyInfo = addressInfo[i]
          data = this.addressInfo[0]
          this.addressInfo[0] = this.addressInfo[i]
          this.addressInfo[i] = data
        } else {
          this.addressInfo[i].reName = addressInfo[i].city.substring(0, 2)
        }
      }
    },
    changeIt (data) {
      const address = data.province + data.city + data.address
      this.companyInfo = data
      this.showMaps(address)
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          this.zxlyFormInfo.msgstate = '0'
          this.$http.post('/admin/addMsg', this.zxlyFormInfo).then(res => {
            this.loading = false
            if (res.data.code === 200) {
              alert('提交成功')
            } else {
              alert('提交失败')
            }
            this.zxlyFormInfo = {}
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  },
  directives: {
    // 进场动画指令：内容默认可见，动画仅作「进场增强」。
    // 视口内或已进入视口时加 reveal-in 播放渐显；即使回调未触发，内容也始终可见，不会被藏死。
    reveal: {
      inserted (el, binding) {
        const delay = binding.value || 0
        el.style.setProperty('--reveal-delay', delay + 'ms')
        const vh = window.innerHeight || document.documentElement.clientHeight
        const rect = el.getBoundingClientRect()
        if (rect.top < vh && rect.bottom > 0) {
          requestAnimationFrame(() => el.classList.add('reveal-in'))
        } else {
          const io = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                el.classList.add('reveal-in')
                io.unobserve(el)
              }
            })
          }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' })
          io.observe(el)
        }
      }
    }
  },
  created () {
    this.getCompanyList()
    this.getTableData()
  }
}
</script>

<style lang="less" scoped>
.lxss_container {
    --ss-green-800: #163a2b;
    --ss-green: #2e6b4f;
    --ss-green-200: #e3ece5;
    --ss-sand: #f7f5f0;
    --ss-gold: #c9a86a;

    width: 100%;
    background: #fff;
    border-radius: 8px;
    padding: 0 0 16px;
    overflow: hidden;
}

/* 栏目分类胶囊 */
.lxss_tabs {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    padding: 18px 24px;
    border-bottom: 1px solid #ece8df;
}
.lxss_tab {
    padding: 8px 22px;
    border-radius: 999px;
    font-size: 15px;
    color: #5b6b62;
    cursor: pointer;
    border: 1px solid transparent;
    transition: background .3s ease, color .3s ease, box-shadow .3s ease;
}
.lxss_tab:hover {
    color: var(--ss-green);
    background: #eef3f0;
}
.lxss_tab.active {
    background: var(--ss-green);
    color: #fff;
    box-shadow: 0 4px 12px rgba(22, 58, 43, .18);
}

.lxss_content {
    padding: 24px;
}

/* 进场动画（默认可见 + 渐显，防呆不隐藏） */
.reveal-init { }
.reveal-init.reveal-in {
    animation: lxssReveal .7s cubic-bezier(.22, .61, .36, 1) both;
    animation-delay: var(--reveal-delay, 0ms);
}
@keyframes lxssReveal {
    from { opacity: 0; transform: translateY(26px); }
    to   { opacity: 1; transform: none; }
}

/* 面板显隐（保留常驻挂载，避免视频/地图状态丢失） */
.lxss_panel {
    width: 100%;
    min-height: 200px;
    overflow: hidden;
}
.lxss_panel_hide {
    width: 100%;
    height: 0;
    overflow: hidden;
}

/* 联系我们 */
.lxwm_container {
    width: 100%;
}
.lxwm_map_container {
    width: 50%;
    float: left;
}
.lxwm__content_container {
    width: 50%;
    padding: 5px 10px;
    float: left;
}
.lxwm__content_body {
    width: 100%;
    padding: 10px 0;
}
.lxwm__name_container {
    width: 100%;
    padding: 10px;
    font-size: 150%;
    color: var(--ss-green-800);
}
.lxwm__tel_container,
.lxwm__address_container {
    width: 100%;
    padding: 5px 10px;
    font-size: 100%;
    color: #3a4a42;
}
.lxwm__btns_body {
    width: 100%;
    padding: 10px 0;
}
.lxwm__btns_body .el-button {
    margin: 5px 8px;
    border: 0;
    border-radius: 6px;
    color: #fff;
    background: var(--ss-green);
    padding: 10px 20px;
    transition: background .3s ease, transform .3s ease;
}
.lxwm__btns_body .el-button:hover {
    background: var(--ss-green-800);
    transform: translateY(-2px);
}
@media screen and (max-width: 768px) {
    .lxwm_map_container,
    .lxwm__content_container {
        width: 100%;
        float: none;
    }
    .lxwm__content_container { padding: 0; }
}

/* 咨询服务 */
.zxfw_container {
    width: 100%;
    padding: 10px 0;
}
.zxfw_zxly_container {
    width: 55%;
    margin: 0 2%;
    float: left;
    border: 1px solid var(--ss-green-200);
    border-radius: 10px;
}
.zxfw_csxx_container {
    width: 40%;
    float: left;
}
.zxfw_zxly_title {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80px;
    letter-spacing: .1rem;
}
.zxfw_zxly_title_ch {
    color: var(--ss-green-800);
    font-size: 200%;
    font-weight: 200;
}
.zxfw_zxly_title_en {
    color: var(--ss-gold);
    font-size: 200%;
    font-weight: 200;
}
.dot {
    height: 10px;
    width: 10px;
    margin: 0 10px;
    border-radius: 50%;
    background-color: var(--ss-gold);
}
.zxfw_zxly_form_container {
    width: 100%;
    padding: 10px 0;
    min-height: 420px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.zxfw_zxly_form_body {
    width: 80%;
    margin: 0 auto;
}
.zxfw__content_body {
    width: 100%;
    padding: 10px 0;
}
.zxfw__name_container {
    width: 100%;
    padding: 10px;
    font-size: 150%;
    color: var(--ss-green-800);
}
.zxfw__net_container,
.zxfw__tel_container,
.zxfw__address_container {
    width: 100%;
    padding: 10px;
    font-size: 100%;
    color: #3a4a42;
}
.zxfw__gzhewm_container {
    width: 200px;
    padding: 10px;
    font-size: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.zxfw__gzhewm_container .el-image {
    width: 200px;
}
@media screen and (max-width: 768px) {
    .zxfw_zxly_container,
    .zxfw_csxx_container {
        width: 100%;
        float: none;
        margin: 0 0 16px;
    }
}

/* 周边旅游 */
.zxly_container {
    width: 100%;
    height: 500px;
}
.swiper {
    width: 100%;
    height: 100%;
}
.swiper .swiper-slide {
    width: 100%;
    height: 100%;
    background-color: #fff;
}
.zbly_item_container {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}
.zbly_img_container {
    width: 60%;
    height: 100%;
}
.zbly_img_container .el-image {
    width: 100%;
    height: 100%;
}
.zbly_content_container {
    width: 40%;
    height: 100%;
    padding: 5px 10px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.zbly_title_container {
    width: 100%;
    padding: 2px 0;
    font-size: 150%;
    font-weight: 200;
    color: var(--ss-green-800);
    letter-spacing: .1rem;
}
.zbly_text_container {
    width: 100%;
    padding: 2px 0;
    font-size: 100%;
    line-height: 150%;
    font-weight: 200;
    color: #56635b;
    letter-spacing: .1rem;
    text-indent: 2em;
}
@media screen and (max-width: 500px) {
    .zxly_container { height: 600px; }
    .zbly_item_container { flex-direction: column; }
    .zbly_img_container,
    .zbly_content_container { width: 100%; height: 50%; }
}
</style>
